import React from 'react';

import type { FieldType } from '../../parsing/parser';
import type { FormFieldDef, FormFieldTextDef } from '../../types';
import { Text } from '../input/Text';
import { FieldControlLabel } from './FieldControlLabel';

type FieldControlTextProps = {
  hasLabel: boolean;
  isRequired: boolean;
  errorMessage: string;
  commonProps: any;
  meta: FormFieldTextDef;
  disabled?: boolean;
  confidenceScore?: number;
  showConfidence?: boolean;
  fieldId: string;
  formId: string;
  // RAG props
  enableRag?: boolean;
  submissionId?: string;
  fieldType?: FieldType;
  fieldMeta?: FormFieldDef;
};

export const FieldControlText = ({
  hasLabel,
  isRequired,
  commonProps,
  errorMessage,
  meta,
  disabled,
  confidenceScore,
  showConfidence = false,
  fieldId,
  formId,
  enableRag,
  submissionId,
  fieldType,
  fieldMeta,
}: FieldControlTextProps) => {
  return (
    <React.Fragment>
      <FieldControlLabel
        hasLabel={hasLabel}
        isRequired={isRequired}
        text={meta.text}
        confidenceScore={confidenceScore}
        showConfidence={showConfidence}
        fieldId={fieldId}
        formId={formId}
        enableRag={enableRag}
        submissionId={submissionId}
        fieldType={fieldType}
        fieldMeta={fieldMeta}
      />

      <Text
        {...commonProps}
        onChange={(val) => commonProps.onChange({ value: val })}
        value={commonProps.value.value}
        multiline={meta.multiline}
        error={errorMessage}
        disabled={disabled}
      />
    </React.Fragment>
  );
};
